import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class IndentEditing extends Plugin {
  init() {
    const editor = this.editor;

    editor.keystrokes.set( 'Tab', ( data, cancel ) => {
      // Uses 'indentBlock' in same way as Increase Indent button in Toolbar
      const command = editor.commands.get( 'indentBlock' );
      if ( command.isEnabled && !this.editor.isReadOnly ) {
        command.execute();
        // cancel() retains cursor and focus on same line or paragraph when 'Tab' is pressed
        cancel();
      }
    } );

    // Uses 'outdentBlock' in same way as Decrease Indent button in Toolbar
    editor.keystrokes.set( 'Shift+Tab', ( data, cancel ) => {
      const command = editor.commands.get( 'outdentBlock' );
      if ( command.isEnabled && !this.editor.isReadOnly ) {
        command.execute();
        // cancel() retains cursor and focus on same line or paragraph when 'Tab' is pressed
        cancel();
      }
    } );
  }
}
